import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetStaticDataDate = (documentTypeId: number) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-static-data-date', { documentTypeId }],
        queryFn: async () => {
            const response = await zoneApiClient.getStaticDataDate(documentTypeId);

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve report date.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: 0,
        cacheTime: 0,
    });
};
